export default () => ({
    list: [],
    errors: {},
    isLoading: false,
});
